<template>
  <div id="add-hashtag">
    <alert-dynamic-component
      :key="res_key"
      v-if="res == 'berhasil'"
      type="success"
      title="Berhasil!"
      subtitle="Hashtag berhasil ditambahkan."
    />
    <alert-dynamic-component
      :key="res_key"
      v-if="res == 'gagal'"
      type="danger"
      title="Gagal!"
      :subtitle="res_message"
    />
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group">
        <label for="addhashtag">Hashtag</label>
        <div class="form-group input-group transparent">
          <div class="input-group-prepend">
            <span class="input-group-text transparent"
              ><i class="bi bi-hash"></i
            ></span>
          </div>
          <input
            type="text"
            v-model="hashtag"
            placeholder="Masukan Hashtag"
            class="form-control"
            required
          />
        </div>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-complete">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import alert_dynamic from "@/views/components/alert_dynamic.vue";

export default {
  name: "modal_add_hashtag",
  components: {
    "alert-dynamic-component": alert_dynamic,
  },
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      hashtag: null,
      res: null,
      project_detail: this.data[0],
      res_key: 0,
      res_message: "",
    };
  },
  methods: {
    submitForm: function () {
      this.res = null;
      let params = {
        _id: this.project_detail._id,
        hashtag: this.hashtag,
      };
      let api = process.env.VUE_APP_API_URL + "hashtag-add";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$parent.$parent.getHashtag();
            this.hashtag = null;
            this.res = "berhasil";
          } else {
            this.res = "gagal";
          }
        })
        .catch((error) => {
          console.log(error);
          this.res_message = "Hashtag gagal ditambahkan. ";
          this.res_message += error.response.data.status;
          this.res = "gagal";
        })
        .finally(() => {
          this.res_key++;
        });
    },
  },
};
</script>